import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';
import { inIframe } from '../../helpers';
import Routes from '../../router/routes';

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  iframeAppBarSpacer: {
    display: 'none',
  },
  content: {
    flexGrow: 1,
    backgroundColor: '#fafafa',
    height: 'calc(100vh - 70px)',
    overflow: 'auto',
  },
  iframeContent: {
    height: '100vh',
    backgroundColor: 'transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    height: 'auto',
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  iframeContainer: {
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

export default function AppBody({ children }) {
  const classes = useStyles();

  return (
    <main className={clsx(classes.content, inIframe() && classes.iframeContent)}>
      <div className={clsx(classes.appBarSpacer, inIframe() && classes.iframeAppBarSpacer)} />
      <Container maxWidth={false} className={clsx(classes.container, inIframe() && classes.iframeContainer)}>
        <Routes />
        { children }
      </Container>
    </main>
  );
}
